<template>
    <div class="booking-list">
        <div class="header text-center h-48">
            <span>受付枠設定</span>
        </div>
        <div class="p-25" style="position: relative">
            <el-select @change="(e) => { return handleSelectPharmacy(e) }"
              class="pharmacist-select" v-model="selectedPharmacyId"
              placeholder="薬剤師">
                <el-option
                        v-for="item in pharmacies"
                        :key="item.id"
                        :label="item.pmc_dsp_name"
                        :value="item.id">
                </el-option>
            </el-select>
            <BulkSettings
              @afterCopy="specifyWeek"
              :firstDayOfWeek="firstDayOfWeek"
              :pharmacy="currentPharmacy()"
              @resetChangeSatus="resetChangeSatus"
              :isChanged="isChanged"></BulkSettings>

            <div class="button-control mb-15">
                <div @click="prevWeek()" class="pre-button">
                    <span class="cursor-pointer">
                        <img src="../../assets/icon/arrow-left.png" alt="">
                        <span>先週を確認</span>
                    </span>
                </div>
                <div @click="handleClickHelpCalendarModal()" class="current-week text-center">
                    <span class="cursor-pointer">カレンダーで週を切替</span>
                </div>
                <div @click="nextWeek()" class="next-button text-right">
                   <span class="cursor-pointer">
                        <span>次週を確認</span>
                        <img src="../../assets/icon/arrow-right.png" alt="">
                   </span>
                </div>
            </div>
            <div class="position-relative" v-loading="loadingListBookingTable">
                <div class="table-scroll" id="table-scroll">
                        <table class="booking-table text-center" id="booking-table">
                            <thead>
                            <tr>
                                <th></th>
                                <th v-if="daysDisplay[0]">{{`${daysDisplay[0].month}月${daysDisplay[0].day}日`}}（月）</th>
                                <th v-if="daysDisplay[1]">{{`${daysDisplay[1].month}月${daysDisplay[1].day}日`}}（火）</th>
                                <th v-if="daysDisplay[2]">{{`${daysDisplay[2].month}月${daysDisplay[2].day}日`}}（水）</th>
                                <th v-if="daysDisplay[3]">{{`${daysDisplay[3].month}月${daysDisplay[3].day}日`}}（木）</th>
                                <th v-if="daysDisplay[4]">{{`${daysDisplay[4].month}月${daysDisplay[4].day}日`}}（金）</th>
                                <th v-if="daysDisplay[5]">{{`${daysDisplay[5].month}月${daysDisplay[5].day}日`}}（土）</th>
                                <th v-if="daysDisplay[6]">{{`${daysDisplay[6].month}月${daysDisplay[6].day}日`}}（日）</th>
                            </tr>
                            </thead>
                            <tbody id="tbody-booking" style="">
                            <tr v-for="(item, index) in listTime" :key="index" :id="item.time">
                                <td style="position: relative;" >{{item.time}}</td>
                                <td v-for="(item2, index2) in item.days_display" :key="index2" :class="{'is-expired': item2.is_expired}" @click="handleClickCalendarCell(index, index2)">
                                  <div v-if="item2.discontinuation">
                                    <span>中止</span>
                                  </div>
                                  <div v-else-if="item2.is_expired">
                                    <span v-if="item2.other_booked"
                                          class="circle-marker setting other-booked banned"></span>
                                    <span v-else
                                          class="circle-marker setting banned"
                                          :class="{'booked': item2.is_booked}"></span>
                                  </div>
                                  <div v-else>
                                    <span v-if="item2.other_booked"
                                          @click.stop="showErrorMessage('この受付枠は予約が入っているため、削除できません')"
                                          :id="`circle-marker_${index}_${index2}`"
                                          class="circle-marker setting other-booked"></span>

                                    <span v-else
                                          @click.stop="(e) => clickTimeBooking(e, item, item2)"
                                          class="circle-marker setting cursor-pointer"
                                          :id="`circle-marker_${index}_${index2}`"
                                          :class="{'booked': item2.is_booked}"></span>
                                  </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
            </div>
            <div class="list-status-booking mt-10 mb-15">
                <div class="wait-accept">
                    <span class="circle-marker"></span>
                    <span>現在選択中の受付枠ですので「保存する」ボタンを押して確定が必要です。</span>
                </div>
                <div class="accepted">
                    <span class="circle-marker"></span>
                    <span>すでに保存された設定済みの受付枠です（再選択する事で解除が可能です）。</span>
                </div>
                <div class="pending">
                    <span class="circle-marker"></span>
                    <span>現在「予約確定」「予約承認待ち」が存在するので解除はできない受付枠です。</span>
                </div>
            </div>
            <div class="container-370 text-center">
                <span @click="handleSaveBooking(selectedListBooking, selectedListBookingWillDelete)" class="save button success w-175 ml-10">保存する</span>
            </div>
        </div>
        <div class="modal-overlay" v-if="showModal">
            <div class="modal">
            <div class="modal-header">
                <div @click="handlecloseHelpCalendarModal()" class="button default">X 閉じる</div>
            </div>
            <div class="modal-body">
                <Calendar @dateChanged="specifyWeek"
                  :init-date="firstDayOfWeek" :auto-set-today="false"
                  :pharmacy="currentPharmacy()" :meeting="{start_at: firstDayOfWeek}"></Calendar>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import CalendarApi from '@/api/calendar'
import MasterDataApi from '@/api/master'
import {apiErrorDialog} from '@/helpers'
import {zeroPadNumber, fixMomentInvalidDate} from '../../helpers'
import BulkSettings from '@/components/BulkSettings'
import Calendar from '@/components/Calendar'
import _ from 'lodash'
// import watcher from '../../../node_modules_2.9/element-ui/packages/table/src/store/watcher'

export default {
  components: {
    BulkSettings,
    Calendar
  },
  data () {
    return {
      listTime: [],
      calendars: [],
      loadingListBookingTable: false,
      pharmacies: this.$auth.user().pharmacies,
      selectedPharmacyId: this.$auth.user().pharmacies[0].id,
      oldSelectedPharmacyId: this.$auth.user().pharmacies[0].id,
      selectedListBooking: [],
      selectedListBookingWillDelete: [],
      firstDayOfWeek: moment(this.now).startOf('week').add(1, 'days').format('YYYY-MM-DD'),
      endDayOfWeek: moment(this.now).endOf('week').add(1, 'days').format('YYYY-MM-DD'),
      daysDisplay: [],
      now: moment(new Date()).format('YYYY-MM-DD'),
      startTimeBooking: moment(this.now).startOf('week').add(1, 'days').format('YYYY-MM-DD 00:00:00'),
      endTimeBooking: moment(this.now).startOf('week').add(7, 'days').format('YYYY-MM-DD 23:59:59'),
      distantTime: 30,
      showModal: false,
      isChanged: false
    }
  },
  methods: {
    async handleChangeWeek () {
      this.daysDisplay = []
      this.firstDayOfWeek = moment(this.now).startOf('week').add(1, 'days').format('YYYY-MM-DD 00:00:00')
      this.endDayOfWeek = moment(this.now).endOf('week').add(1, 'days').format('YYYY-MM-DD 23:59:59')
      await this.fetchDateTime()
    },
    nextWeek () {
      if (!this.showConfirmingChangeDialog()) return

      this.now = moment(this.now).add(7, 'days').format('YYYY-MM-DD')
      this.startTimeBooking = moment(this.startTimeBooking).add(7, 'days').format('YYYY-MM-DD 00:00:00')
      this.endTimeBooking = moment(this.endTimeBooking).add(7, 'days').format('YYYY-MM-DD 23:59:59')
      this.scrollTableToLeft()
      this.handleChangeWeek()
      this.initializeStatus()
    },
    prevWeek () {
      if (!this.showConfirmingChangeDialog()) return

      this.loadingListBookingTable = true
      this.now = moment(this.now).subtract(7, 'days').format('YYYY-MM-DD')
      this.startTimeBooking = moment(this.startTimeBooking).subtract(7, 'days').format('YYYY-MM-DD 00:00:00')
      this.endTimeBooking = moment(this.endTimeBooking).subtract(7, 'days').format('YYYY-MM-DD 23:59:59')
      this.scrollTableToLeft()
      this.handleChangeWeek()
      this.initializeStatus()
    },
    async currentWeek () {
      if (!this.showConfirmingChangeDialog()) return

      this.loadingListBookingTable = true
      this.now = moment(new Date()).format('YYYY-MM-DD')
      this.startTimeBooking = moment(this.now).startOf('week').add(1, 'days').format('YYYY-MM-DD 00:00:00')
      this.endTimeBooking = moment(this.now).startOf('week').add(7, 'days').format('YYYY-MM-DD 23:59:59')
      this.scrollTableToLeft()
      await this.handleChangeWeek()
      this.initializeStatus()
    },
    async specifyWeek (date) {
      if (!this.showConfirmingChangeDialog()) return

      this.loadingListBookingTable = true
      this.now = date.format('YYYY-MM-DD')
      this.startTimeBooking = moment(this.now).startOf('week').add(1, 'days').format('YYYY-MM-DD 00:00:00')
      this.endTimeBooking = moment(this.now).startOf('week').add(7, 'days').format('YYYY-MM-DD 23:59:59')
      this.scrollTableToLeft()
      await this.handleChangeWeek()
      this.showModal = false
      this.initializeStatus()
    },
    handleSelectPharmacy (pharmacyId) {
      if (!this.showConfirmingChangeDialog()) {
        this.selectedPharmacyId = this.oldSelectedPharmacyId
        return false
      }

      this.selectedPharmacyId = pharmacyId
      this.oldSelectedPharmacyId = this.selectedPharmacyId
      this.currentWeek()
    },
    async handleSaveBooking (selectedListBooking, selectedListBookingWillDelete) {
      this.loadingListBookingTable = true
      const pharID = this.selectedPharmacyId ? this.selectedPharmacyId : this.$auth.user().pharmacies[0].id

      if (selectedListBooking.length > 0) {
        await CalendarApi.savePharmacyCalendar({
          times: selectedListBooking
        }, pharID)
          .catch((error) => {
            apiErrorDialog(this, error)
          })
      }

      if (selectedListBookingWillDelete.length > 0) {
        await CalendarApi.deletePharmacyCalendar({calendar_ids: this.selectedListBookingWillDelete}, pharID)
          .catch((error) => {
            apiErrorDialog(this, error)
          })
      }

      await this.fetchDateTime(true)

      this.initializeStatus()
      this.loadingListBookingTable = false
    },
    initializeStatus () {
      this.selectedListBooking = []
      this.selectedListBookingWillDelete = []
      this.resetChangeSatus()

      // reset all selected cells.
      let selectedMarkers = document.getElementsByClassName('selected-marker')
      let removingCells = []
      for (let i = 0; i < selectedMarkers.length; i++) {
        removingCells.push(selectedMarkers[i])
      }
      removingCells.forEach((elem) => elem.classList.toggle('selected-marker'))
    },
    clickTimeBooking (e, itemTime, time) {
      e.target.classList.toggle('selected-marker')
      const dateTime = `${itemTime.time}|${time.year}-${time.month}-${time.day}`
      const isBooked = time.is_booked
      const calendarId = time.id
      if (!isBooked) {
        const arrayDateTime = dateTime.split('|')
        const timeArray = arrayDateTime[0].split('-')
        const date = moment(fixMomentInvalidDate(arrayDateTime[1])).format('YYYY-MM-DD')
        const startTime = `${date} ${timeArray[0].replace(/ /g, '')}`
        const endTime = `${date} ${timeArray[1].replace(/ /g, '')}`
        const startTimeDisplay = moment(startTime).format('YYYY-MM-DD HH:mm:ss')
        const endTimeDisplay = moment(endTime).format('YYYY-MM-DD HH:mm:ss')
        const index = _.findIndex(this.selectedListBooking, n => n.start === startTimeDisplay)
        if (index === -1) {
          this.selectedListBooking = [...this.selectedListBooking, {start: startTimeDisplay, end: endTimeDisplay}]
        } else {
          _.remove(this.selectedListBooking, n => n.start === startTimeDisplay)
          this.selectedListBooking = [...this.selectedListBooking]
        }
      } else {
        const index = _.findIndex(this.selectedListBookingWillDelete, n => n === calendarId)
        if (index === -1) {
          this.selectedListBookingWillDelete = [...this.selectedListBookingWillDelete, calendarId]
        } else {
          _.remove(this.selectedListBookingWillDelete, n => n === calendarId)
          this.selectedListBookingWillDelete = [...this.selectedListBookingWillDelete]
        }
      }

      this.isChanged = true
    },
    showErrorMessage (msg) {
      this.$message.error(msg)
    },
    async fetchDateTime (isSave) {
      this.loadingListBookingTable = true
      this.daysDisplay = []
      if (isSave) this.firstDayOfWeek = moment(this.firstDayOfWeek).subtract(7, 'days')
      for (let i = 0; i < 7; i++) {
        let firstDayOfWeek = this.firstDayOfWeek
        let listTime = []
        // start time is 00:00
        let startListTime = fixMomentInvalidDate(`${moment(firstDayOfWeek).year()}-${moment(firstDayOfWeek).month() + 1}-${moment(firstDayOfWeek).date()}`) + ' 00:00'
        let endListTime = moment(startListTime).add(this.distantTime, 'minutes').format('YYYY-MM-DD HH:mm')
        for (let j = 0; j < this.listTime.length; j++) {
          let startTimeDisplay = moment(startListTime).format('HH:mm')
          let endTimeDisplay = moment(endListTime).format('HH:mm')
          listTime.push(
            {
              start_at: `${startTimeDisplay}`,
              end_at: `${endTimeDisplay}`,
              time: `${startTimeDisplay} - ${endTimeDisplay}`,
              month: `${moment(firstDayOfWeek).month() + 1}`,
              day: `${moment(firstDayOfWeek).date()}`,
              year: `${moment(firstDayOfWeek).year()}`
            }
          )
          startListTime = moment(startListTime).add(this.distantTime, 'minutes').format('YYYY-MM-DD HH:mm')
          endListTime = moment(endListTime).add(this.distantTime, 'minutes').format('YYYY-MM-DD HH:mm')
        }
        this.daysDisplay.push(
          {
            day: moment(this.firstDayOfWeek).date(),
            month: moment(this.firstDayOfWeek).month() + 1,
            year: moment(this.firstDayOfWeek).year()
          }
        )
        this.firstDayOfWeek = moment(this.firstDayOfWeek).add(1, 'days').format('YYYY-MM-DD')
      }
      await this.fetchListBooking()
      setTimeout(() => { this.loadingListBookingTable = false }, 500)
    },
    scrollTableToLeft () {
      const bookingTable = document.getElementById('booking-table')
      bookingTable.scrollLeft = 0
    },

    async fetchListBooking () {
      const calendarRes = await CalendarApi.getByPharmacyId(
        {
          start: this.startTimeBooking,
          end: this.endTimeBooking
        }, this.selectedPharmacyId ? this.selectedPharmacyId : this.$auth.user().pharmacies[0].id
      )
        .catch((error) => {
          apiErrorDialog(this, error)
        })
      this.calendars = calendarRes.data.data
      let listCalendarsRes = []
      this.calendars.forEach(calendar => {
        const tbYear = moment(calendar.start).year()
        const tbMonth = zeroPadNumber(moment(calendar.start).month() + 1)
        const tbDay = zeroPadNumber(moment(calendar.start).date())
        const tbStartHour = zeroPadNumber(moment(calendar.start).hours())
        const tbStartMin = zeroPadNumber(moment(calendar.start).minutes())
        const tbEndHour = zeroPadNumber(moment(calendar.end).hours())
        const tbEndMin = zeroPadNumber(moment(calendar.end).minutes())
        let timeBooked = `${tbYear}-${tbMonth}-${tbDay} ${tbStartHour}:${tbStartMin} - ${tbEndHour}:${tbEndMin}`
        listCalendarsRes.push({
          time: timeBooked,
          id: calendar.id,
          used_by_other_user: calendar.used_by_other_user,
          discontinuation: calendar.discontinuation
        })
        calendar.time = timeBooked
      })
      this.handleData()
    },
    fetchConstListTime (start = '00:00', end = '23:30', step = 30) {
      let listTime = []
      let startTime = moment().format(`YYYY-MM-DD ${start}`)
      let endtime = moment().format(`YYYY-MM-DD ${end}`)
      while (moment(startTime).isBefore(endtime)) {
        listTime.push({time: `${moment(startTime).format('HH:mm')} - ${moment(startTime).add(step, 'minutes').format('HH:mm')}`})
        startTime = moment(startTime).add(step, 'minutes')
      }
      this.listTime = listTime
    },
    getStartTime (time) {
      return time.split('-')[0].trim('')
    },
    getEndTime (time) {
      return time.split('-')[1].trim('')
    },
    async handleData () {
      for (let i = 0; i < this.listTime.length; i++) {
        Object.assign(this.listTime[i], {
          days_display: JSON.parse(JSON.stringify(this.daysDisplay))
        })
        for (let j = 0; j < 7; j++) {
          let objTime = this.listTime[i].days_display[j]
          Object.assign(this.listTime[i].days_display[j], {
            time: `${objTime.year}-${zeroPadNumber(objTime.month)}-${zeroPadNumber(objTime.day)} ${this.listTime[i].time}`,
            start_at: `${objTime.year}-${zeroPadNumber(objTime.month)}-${zeroPadNumber(objTime.day)} ${this.getStartTime(this.listTime[i].time)}:00`,
            end_at: `${objTime.year}-${zeroPadNumber(objTime.month)}-${zeroPadNumber(objTime.day)} ${this.getEndTime(this.listTime[i].time)}:00`
          })
        }
      }
      // comparation and get status of cell
      for (let i = 0; i < this.listTime.length; i++) {
        const listTimeItem = this.listTime[i]
        for (let j = 0; j < 7; j++) {
          const daysDisplayItem = listTimeItem.days_display[j]
          let isExpired = null
          let startAt = daysDisplayItem.start_at
          if (moment().isAfter(moment(startAt))) isExpired = true
          Object.assign(this.listTime[i].days_display[j], {
            is_expired: isExpired
          })
          for (let m = 0; m < this.calendars.length; m++) {
            const carlendarResItem = this.calendars[m]
            if (daysDisplayItem.time === carlendarResItem.time) {
              Object.assign(this.listTime[i].days_display[j], {
                is_booked: true,
                discontinuation: carlendarResItem.discontinuation,
                other_booked: carlendarResItem.used_by_other_user,
                id: carlendarResItem.id
              })
            }
          }
        }
      }

      const res = await MasterDataApi.get()
        .catch((error) => {
          apiErrorDialog(this, error)
        })
      const masterData = res.data.data
      const elm = document.getElementById(`${masterData.fixed_time_scrool}`)
      // location.href = `#${masterData.fixed_time_scrool}`
      // const tableScroll = document.getElementById('table-scroll')
      // tableScroll.scrollTop = tableScroll.scrollTop - elm.offsetHeight + 5
      const tableScroll = document.getElementById('table-scroll')
      tableScroll.scrollTop = elm.offsetTop - 38
    },
    handleClickCalendarCell (index, index2) {
      document.getElementById(`circle-marker_${index}_${index2}`).click()
    },
    currentPharmacy () {
      const $ = this
      let index = 0
      if ($.selectedPharmacyId) {
        index = _.findIndex(this.pharmacies, n => n.id === $.selectedPharmacyId)
      }

      return this.pharmacies[index]
    },
    handleClickHelpCalendarModal () {
      if (!this.showConfirmingChangeDialog()) return

      this.showModal = true
    },
    handlecloseHelpCalendarModal () {
      this.showModal = false
    },
    showConfirmingChangeDialog () {
      let isOk = true
      if (this.isChanged) {
        isOk = window.confirm('受付枠の設定が変更されましたが保存されていません。設定内容を破棄してもよろしいですか？')
        if (isOk) {
          this.resetChangeSatus()
        }
      }
      return isOk
    },
    resetChangeSatus () {
      this.isChanged = false
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.showConfirmingChangeDialog()) {
      next()
    } else {
      next(false)
    }
  },
  async mounted () {
    await this.fetchConstListTime()
    await this.fetchDateTime()
  }
}
</script>
<style scoped>
  @media (max-width: 600px) {
    .modal-overlay .modal {
      width: 85%;
      left: 57%;
    }
  }
  @media (max-height: 400px) {
    .modal-overlay .modal {
      top: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Calendar/Settings.vue